import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class IVendor {
  id: string | number;
  code: string;
  pointId: number;
  userId: string | number;
  companyId: string | number;
  groupNumber: number;
  hidden: number;
  regionId: string | number;
}

export class IPostVendorBoyDto {
  code: string;
  pointId: string | number;
  companyId: string | number;
  userId: number | null;
  hidden: number;
  regionId: number | null;
  groupNumber: number | null;
  vendorGroupId?: number | null;
}

export class IPatchVendorBoyDto {
  code?: string;
  pointId?: number;
  userId?: number;
  companyId?: number | string;
  groupNumber?: number;
  hidden?: number;
  regionId?: number;
}

export class IVendorResponse {
  @Type(() => IVendor)
  result: IVendor;
}

export class IVendorListResponse extends IPagination {
  @Type(() => IVendor)
  results: IVendor[];
}

export class IVendorQueryDto extends IQueryPaginationDto {
  name?: string;
  pointId?: number;
  code?: string;
  companyName?: string;
  companyId?: string | number;
  hidden?: number;
  action?: string;
  ilId?: number;
  ilceId?: string | number;
}
